import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { ProductItem } from '../models/Product';

export const list = (): AxiosPromise<ProductItem[]> => {
  return axios.get('/api/products');
};